import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const VatMessage = ({ isHost = false, intl }) => {
  return (
    <div className="border rounded-border vat-box">
      <div className="flex middle margin-lg-bottom">
        <img
          className="brand-logo-dark margin-md-right"
          src="https://assets.peerspace.com/signage.svg?v=rb"
          alt={ intl.formatMessage({ id: 'inbox.vat_message.signage', defaultMessage: 'Signage Icon' }) }
        />
        <strong className="text-gray-darker">
          <FormattedMessage
            id="inbox.vat_message.tax"
            defaultMessage="Value-Added Tax"
          />
        </strong>
      </div>
      {
        isHost
          ? <p className="text-gray-dark">
            <span data-testing-id="host-vat-message">
              <FormattedMessage
                id="inbox.vat_message.explanation_for_host_part_1"
                defaultMessage="If you’re registered for VAT, then you can add your tax ID to your Peerspace account {link_1}. This will ensure your invoices are accurate and the correct tax rate for your business is applied."
                values={{
                  link_1: <a href='https://www.peerspace.com/account/taxes' className='underline'>
                    <FormattedMessage id="here" defaultMessage="here" />
                  </a>
                }}
              />
            </span>
            <br /><br />
            <span data-testing-id="shared-vat-message">
              <FormattedMessage
                id="inbox.vat_message.explanation_for_host_part_2"
                defaultMessage="Peerspace is required to charge VAT on the Peerspace Service Fees on all transactions. You can find and download all the taxes that Peerspace collects in your account {link_2}."
                values={{
                  link_2: <a href='https://www.peerspace.com/account/taxes' className='underline'>
                    <FormattedMessage id="inbox.vat_message.here" defaultMessage="here" />
                  </a>
                }}/>
            </span>
          </p>
          : <p className="text-gray-dark">
            <span data-testing-id="shared-vat-message">
              <FormattedMessage
                id="inbox.vat_message.explanation_for_guest"
                defaultMessage="Peerspace is required to charge VAT on the Peerspace Service Fees on all transactions. You can find and download all the taxes that Peerspace collects in your account {link}."
                values={{
                  link: <a href='https://www.peerspace.com/account/taxes' className='underline'>
                    <FormattedMessage id="inbox.vat_message.here" defaultMessage="here" />
                  </a>
                }}/>
            </span>
          </p>
      }
    </div>
  );
};

VatMessage.propTypes = {
  isHost: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(VatMessage);
